import { SVGProps } from './types';

const CircleShieldCheckIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#E0EAFF"
      d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
    ></path>
    <path
      fill="#3538CD"
      d="M11.477 19.202c.166.097.249.145.366.17.09.02.223.02.314 0 .117-.025.2-.073.367-.17 1.46-.853 5.476-3.53 5.476-7.211V8.404c0-.6 0-.9-.098-1.157a1.5 1.5 0 0 0-.41-.592c-.207-.183-.488-.288-1.05-.498l-4.02-1.508c-.157-.059-.235-.088-.315-.1a.8.8 0 0 0-.214 0c-.08.012-.158.041-.314.1L7.557 6.157c-.561.21-.842.315-1.049.498a1.5 1.5 0 0 0-.41.592C6 7.504 6 7.804 6 8.404v3.587c0 3.68 4.015 6.358 5.477 7.21"
    ></path>
    <path
      stroke="#EEF4FF"
      strokeLinecap="square"
      strokeWidth="1.313"
      d="m9.75 11.616 1.5 1.5 3.375-3.375M18 11.99c0 3.68-4.015 6.358-5.476 7.21-.167.098-.25.146-.367.171a.9.9 0 0 1-.314 0c-.117-.025-.2-.073-.367-.17C10.017 18.349 6 15.672 6 11.99V8.404c0-.6 0-.9.098-1.157a1.5 1.5 0 0 1 .41-.592c.207-.183.488-.288 1.05-.498l4.02-1.508c.157-.059.235-.088.315-.1a.8.8 0 0 1 .214 0c.08.012.158.041.314.1l4.022 1.508c.561.21.842.315 1.049.498a1.5 1.5 0 0 1 .41.592c.098.257.098.557.098 1.157z"
    ></path>
  </svg>
);

export { CircleShieldCheckIcon };
